import { createActions } from 'redux-actions'

const creators = createActions({
  HIDE_MESSAGE: () => {},
  SHOW_MESSAGE: (payload) => payload
});

export default creators
